module.exports = __webpack_public_path__ + "img/9d2eb30.png";